<section class="camera-selector-container">
  <section class="header">
    <h5 class="h5_500">{{'faceRecognition.selectACamera' | translate}}</h5>
    <button class="close" (click)="close()"><mat-icon>close</mat-icon></button>
  </section>
  <section *ngIf="availableCameras.length > 0" class="mt-3 camera-section">
    <p class="subtitle-1">{{"faceRecognition.multipleCameras" | translate}}</p>
    <div class="camera-selection">
      <mat-checkbox class="cameras body-2" *ngFor="let camera of availableCameras" (change)="onCameraSelected(camera.deviceId)">
        {{camera.label}}
      </mat-checkbox>
    </div>
  </section>
  <div class="alert alert-warning" *ngIf="availableCameras.length === 0 && camerasChecked">
    <img src="../../../assets/images/icons/warning-modal.png" alt="">
    {{'faceRecognition.errors.noCamerasDetected' | translate}}
  </div>
</section>